<template>
    <div class="currency-display">
        {{ currencySymbol }} {{ amount | currency(decimalsApply, applyConvertion) }}
        <span v-if="showCurrencyCode" :style="{ fontSize: reduceIsoFont ? '1rem' : '',fontWeight: fontWeight ? '600' : '' }">{{ currencyCodeMain }}</span>
    </div>
</template>

<script>
    const _settings = window.__pt.settings.site;
    export default {
        props: ['amount', 'showCurrencyCode', 'currencyCode', 'applyDecimals', 'reduceIsoFont', 'applyConvertion', 'applySymbol', 'fontWeight'],
        data() {
            return {
                currencySymbol: this.applySymbol ? "" : _settings.currencySymbol,
                currencyCodeMain:  this.currencyCode ? this.currencyCode :_settings.currencyCodeName,
                decimalsApply: this.applyDecimals ? _settings.decimalDigits: 0
            };
        },
        mounted() {
            this.currencyCodeMain = this.currencyCode ? this.currencyCode : _settings.currencyCodeName;
        },
        methods: {

        }
    }
</script>

<style scoped>
    .currency-display {
        display: inline-block;
    }
</style>